import React from "react";
import DepartementPage from "./DepartementPage";

const AMOEssonne91 = () => {
  return <DepartementPage dept="essonne" />;
};

export default AMOEssonne91;
